import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import Menu, { MenuItem } from 'material-ui/Menu';
import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ChatIcon from '@material-ui/icons/Chat'
import StarIcon from '@material-ui/icons/Star'
import SettingsIcon from '@material-ui/icons/Settings'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import AccountIcon from '@material-ui/icons/AccountCircle'
import Emoticon from '@material-ui/icons/InsertEmoticon'
import Mic from '@material-ui/icons/Mic'
import classNames from 'classnames'
import { Snackbar, Drawer, AppBar, Button, Toolbar, List, ListItem, ListItemIcon, ListItemAvatar, ListItemText, Avatar, Typography, Divider, IconButton, Grid, Paper, Input } from 'material-ui';
import { withCookies } from 'react-cookie'
import request from 'superagent'
import MessageMeText from "./MessageMeText"
import MessagePartnerText from "./MessagePartnerText"
import MessageMeImage from "./MessageMeImage"
import MessagePartnerImage from "./MessagePartnerImage"

const drawerWidth = 280;
const footerHeight = 45;

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: "100%",
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  footer: {
    position: 'absolute',
    display: 'flex',
    backgroundColor: "#32a087",
    zIndex: 2,
    height: 45,
    padding: 13,
    width: "100%",
    bottom: 0,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    backgroundColor: '#FFF8',
    marginTop: 63,
    marginBottom: 45,
  },
});

class Page extends React.Component {
  state = {
    open: false,
    snackbarOpen: true,
    anchorEl: null,
    accData: null,
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  }

  handleDrawerClose = () => {
    this.setState({ open: false });
  }

  handleMenuClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleLogOutClick = () => {
    this.setState({ anchorEl: null });
    this.props.cookies.remove('keepLoggedIn');
    this.props.onLogOut();
  }

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  }

  handleSnackbarClose = () => {
    this.setState({ snackbarOpen: false });
  }

  render() {
    const { classes, theme, accData } = this.props;

    console.log(accData);
    var contacts;
    if(accData.contacts != "no_contacts") {
      contacts = accData.contacts.map(contact =>
        <Fragment>
          <ListItem button>
            <ListItemAvatar>
              <Avatar alt={contact.username} src={contact.image}/>
            </ListItemAvatar>
            <ListItemText primary={contact.username} secondary={contact.status} />
          </ListItem>
          <li><Divider inset /></li>
        </Fragment>
      )
    }
    var groups;
    if(accData.groups != "no_groups") {
      groups = accData.groups.map(group =>
        <Fragment>
          <ListItem button>
            <ListItemAvatar>
              <Avatar alt={group.group_name} src={group.image}/>
            </ListItemAvatar>
            <ListItemText primary={group.group_name} secondary={group.subject} />
          </ListItem>
          <li><Divider inset /></li>
        </Fragment>
      )
    }

    return (
      <Fragment>
        <div className={classes.root}>
          <AppBar position="absolute" className={classNames(classes.appBar, this.state.open && classes.appBarShift)}>
            <Toolbar disableGutters={!this.state.open}>
              <IconButton color="inherit" onClick={this.handleDrawerOpen} className={classNames(classes.menuButton, this.state.open && classes.hide)} >
                <MenuIcon />
              </IconButton>
              <Typography color="inherit" variant="title" style={{flex: 1}} noWrap>Chats</Typography>
              <IconButton color="inherit" area-label="Account-Einstellungen" onClick={this.handleAccountSettingsClick}>
                <AccountIcon/>
              </IconButton>
              <IconButton color="inherit" area-label="Mehr" area-haspopup="true" onClick={this.handleMenuClick}>
                <MoreVertIcon/>
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl)}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                onClose={this.handleMenuClose} >
                <MenuItem key="logout" onClick={this.handleLogOutClick}>Abmelden</MenuItem>
              </Menu>
            </Toolbar>
          </AppBar>
          <Drawer variant="permanent" classes={{paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose)}} open={this.state.open} >
            <div className={classes.toolbar}>
            <Typography variant="title" color="primary">Chatlet&nbsp;Web</Typography>
              <IconButton onClick={this.handleDrawerClose}>
                {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
              </IconButton>
            </div>
            <Divider />
            <List>
              <ListItem button>
                <ListItemIcon><ChatIcon /></ListItemIcon>
                <ListItemText primary="Chats" />
              </ListItem>
              <ListItem button>
                <ListItemIcon><StarIcon /></ListItemIcon>
                <ListItemText primary="Nachrichten&nbsp;mit&nbsp;Stern" />
              </ListItem>
            </List>
            <Divider />
            <List>
            <ListItem button>
              <ListItemIcon><SettingsIcon /></ListItemIcon>
              <ListItemText primary="Einstellungen" />
            </ListItem>
            </List>
          </Drawer>
          <main className={classes.content}>
            <Grid container style={{height: "100%"}}>
              <Grid item xl={3} lg={3} md={4} sm={5} xs={6} style={{backgroundColor: "#FFF"}}>
                {/* Chats */}
                <List style={{backgroundColor: "#FFF", maxHeight: '100%', overflow: 'auto'}}>
                  {contacts}
                  {groups}
                </List>
              </Grid>
              <Grid item xl={9} lg={9} md={8} sm={7} xs={6}>
                {/* Chat space */}
                <Grid container direction="column" style={{height: "100%"}}>
                  <Grid item style={{height: `calc(100% - 76px)`, overflowY: "scroll"}}>
                    {/* Chat space */}
                    <MessageMeText text="Dies ist ein Test. Dies ist noch ein Test." time="10:51"/>
                    <MessagePartnerText text="Hi" time="10:49"/>
                    <MessageMeImage image="http://jakob-schwaiger.de/blog/wp-content/uploads/2016/07/Test.png" text_top="Top" text_bottom="Bottom" time="10:49"/>
                    <MessagePartnerImage image="https://www.w3schools.com/images/colorpicker.gif" text_top="Top" text_bottom="Bottom" time="10:49"/>
                  </Grid>
                  <Grid item style={{height: 50}}>
                    {/* Input bar */}
                    <Paper elevation={3} style={{padding: 6, margin: 8}}>
                      <Grid container>
                        <Grid item style={{width: 50}}>
                          <IconButton aria-label="Emoticon hinzuf&uuml;gen"><Emoticon /></IconButton>
                        </Grid>
                        <Grid item style={{width: `calc(100% - 100px)`}}>
                          <Input placeholder="Schreibe eine Nachricht" style={{marginTop: 8, width: '100%'}}/>
                        </Grid>
                        <Grid item style={{width: 50}}>
                          <IconButton aria-label="Sprachnachricht aufnehmen"><Mic /></IconButton>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </main>
        </div>
        <div className={classes.footer}>
          {/* Footer */}
          <Grid container>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={6}><Typography color="inherit" noWrap>© M&amp;R Games 2018</Typography></Grid>
            <Grid item xl={6} lg={6} md={6} sm={6} xs={6} align="right"><a color="inherit" target="blank" href="https://play.google.com/store/apps/details?id=com.mrgames13.jimdo.chatlet">App herunterladen</a></Grid>
          </Grid>
        </div>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          open={this.state.snackbarOpen}
          onClose={this.handleSnackbarClose}
          autoHideDuration={3000}
          SnackbarContentProps={{ 'aria-describedby': 'message-id' }}
          message={<span id="message-id">Anmeldung erfolgreich!</span>}
          action={[
            <Button key="logout" color="secondary" size="small" onClick={this.handleLogOutClick}>Abmelden</Button>
          ]}
        />
      </Fragment>
    );
  }
}

Page.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  accData: PropTypes.object.isRequired,
}

export default withCookies(withStyles(styles, { withTheme: true })(Page));



// WEBPACK FOOTER //
// ./src/Components/Layout/Page.js